import { render, staticRenderFns } from "./OCheckbox.vue?vue&type=template&id=f1607950&scoped=true"
import script from "./OCheckbox.vue?vue&type=script&lang=js"
export * from "./OCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1607950",
  null
  
)

export default component.exports